"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextLabel = exports.SwitchInput = exports.SwitchErrorContainer = exports.SwitchContainer = exports.Switch = exports.SpinnerContainer = exports.Slider = exports.ErrorLabel = void 0;
const Theme_1 = require("../../Theme/Theme");
exports.ErrorLabel = Theme_1.styled.span `
  color: ${(props) => props.theme.colors.red[50]};
  font-size: ${(props) => props.theme.font.size.xsmall};
  font-family: ${(props) => props.theme.font.family.proximaNova};
`;
exports.Slider = Theme_1.styled.span `
  position: absolute;
  cursor: ${(props) => (props.disabled ? '' : 'pointer')};
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: ${(props) => props.theme.colors.gray[40] + '54'};
  transition: 0.4s;
  border-radius: 34px;

  &:before {
    position: absolute;
    content: '';
    height: 20px;
    width: 20px;
    top: -3px;
    background-color: white;
    border-radius: 50%;
    box-shadow: 0px 1px 2px 1px rgba(0, 0, 0, 0.25);
    transition: 0.4s;
  }

  &:hover::after {
    position: absolute;
    content: '';
    height: ${(props) => (props.disabled || props.loading ? '' : '40px')};
    width: ${(props) => (props.disabled || props.loading ? '' : '40px')};
    background-color: ${(props) => props.disabled || props.loading
    ? ''
    : props.theme.colors.gray[30] + '30'};
    border-radius: 50%;
    top: -13px;
    left: -10px;
    box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.18);
    transition: 0.4s;
  }
`;
exports.SpinnerContainer = Theme_1.styled.div `
  position: absolute;
  left: 2px;
  -webkit-transform: ${(props) => (props.isChecked ? 'translateX(17px)' : '')};
  -ms-transform: ${(props) => (props.isChecked ? 'translateX(17px)' : '')};
  transform: ${(props) => (props.isChecked ? 'translateX(17px)' : '')};
  transition: 0.4s;
`;
exports.Switch = Theme_1.styled.label `
  position: relative;
  display: flex;
  align-items: center;
  width: 36px;
  height: 14px;
`;
exports.SwitchContainer = Theme_1.styled.div `
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: 100%;
`;
exports.SwitchErrorContainer = Theme_1.styled.div `
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  opacity: ${(props) => (props.disabled ? '0.40' : '')};
`;
exports.SwitchInput = Theme_1.styled.input `
  opacity: 0;
  width: 0;
  height: 0;
  &:checked + .slider:before {
    -webkit-transform: translateX(17px);
    -ms-transform: translateX(17px);
    transform: translateX(17px);
    background-color: ${(props) => props.theme.colors.blue[50]};
  }
  &:checked + .slider {
    background-color: ${(props) => props.theme.colors.blue[50] + '54'};
  }
  &:checked + .slider:hover::after {
    -webkit-transform: translateX(17px);
    -ms-transform: translateX(17px);
    transform: translateX(17px);
    background-color: ${(props) => props.theme.colors.blue[50] + '12'};
    box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.2);
  }
`;
exports.TextLabel = Theme_1.styled.span `
  color: ${(props) => props.theme.colors.gray[70]};
  font-size: ${(props) => props.theme.font.size.xsmall};
  font-weight: ${(props) => props.theme.font.weight.bold};
  font-family: ${(props) => props.theme.font.family.proximaNova};
`;
//# sourceMappingURL=SwitchStyles.js.map